'use client'
import React from 'react'
import Script from 'next/script'
// import Logo from '../../public/logo.webp'

const WebCallWidget = () => {
	return (
		<Script
			src='https://app.liaplus.com/embed.js'
			data-assistant-id='d90bfbd9-c49d-4869-a972-1cea093c9de4'
			data-mode='voice'
			data-base-url='https://app.liaplus.com'
			data-server-url='https://app.liaplus.com:7860'
			data-design-theme='metalbook'
			data-client='metalbook'
			data-title='TALK TO AI AGENT'
			data-help-texts='Ask Metalbook,Buy/Sell Metal,Get Metal Quotes,Fabricated Products,Financing Solutions'
			data-languages='[{"name":"Hindi","assistantId":"d90bfbd9-c49d-4869-a972-1cea093c9de4"},{"name":"English","assistantId":"71dc4348-6b38-4eea-bb8e-a852c6b60a1e"}]'
			data-consent-content="By clicking 'Agree,' and each time I interact with this AI agent..."
			data-custom-image-url='/uploads/logos/logo_1761905374946_07s3qaiphuw5.png'
			data-consent-required='false'
			data-agent-display-name='Mitali'
			data-language-selector-enabled='true'
			strategy='afterInteractive'
			onLoad={() => console.log('Liaplus widget loaded!')}
		/>
	)

	// return (
	// 	<Script
	// 		src='https://webcallcdn.z29.web.core.windows.net/web-call-widget.umd.cjs'
	// 		onLoad={(e) => {
	// 			window.WebCallWidget.init({
	// 				assistant: 'Metalbook AI Assistant',
	// 				theme: 'light', //light, dark
	// 				token: process.env.widgetToken, //Provided seperately
	// 				logo: { Logo },
	// 				width: '300px',
	// 				height: '600px',
	// 				widgetStyle: 'collapsed', //collapsed, collapsed-small, open
	// 				primaryColor: '#EA3162',
	// 				secondaryColor: '#F69F02',
	// 				firstMessage: 'Hello! How can I assist you today?',
	// 				primaryMode: 'voice', // chat, voice
	// 				disclaimer:
	// 					'This responses provided by this assistant are generated by AI and are for informational purposes only. Please verify critical information through official channels.',
	// 			})
	// 		}}
	// 	/>
	// )
}

export default WebCallWidget
